
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

export const ChevronRight16 = (p: IconProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path fillRule="evenodd" clipRule="evenodd" d="M6.18939 3.33333L11.1852 8.32913L6.18939 13.3249L5.33333 12.4689L9.47307 8.32913L5.33333 4.18939L6.18939 3.33333Z" fill="currentColor"/>
  </svg>
);

export const ChevronDown24 = (p: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path fillRule="evenodd" clipRule="evenodd" d="M19.9874 9.28409L12.4937 16.7778L5 9.28409L6.28409 8L12.4937 14.2096L18.7033 8L19.9874 9.28409Z" fill="currentColor"/>
  </svg>
);

export const ArrowSortDown24 = (p: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path d="M7 9.5L12 14.5L17 9.5H7Z" fill="currentColor"/>
  </svg>
);

export const LaunchModal16 = (p: IconProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path d="M6.22222 2.66667V4.08889H10.9084L2.66667 12.3307L3.66933 13.3333L11.9111 5.09156V9.77778H13.3333V2.66667H6.22222Z" fill="currentColor"/>
  </svg>
);

export const Search24 = (p: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path d="M21.7 20.3L16.3 14.9C17.4 13.5 18 11.8 18 10C18 7.9 17.2 5.9 15.7 4.3C14.1 2.8 12.1 2 10 2C7.9 2 5.9 2.8 4.3 4.3C2.8 5.9 2 7.9 2 10C2 12.1 2.8 14.1 4.3 15.7C5.9 17.2 7.9 18 10 18C11.8 18 13.5 17.4 14.9 16.3L20.3 21.7L21.7 20.3ZM10 16C8.4 16 6.9 15.4 5.8 14.2C4.6 13.1 4 11.6 4 10C4 8.4 4.6 6.9 5.8 5.8C6.9 4.6 8.4 4 10 4C11.6 4 13.1 4.6 14.2 5.8C15.4 6.9 16 8.4 16 10C16 11.6 15.4 13.1 14.2 14.2C13.1 15.4 11.6 16 10 16Z" fill="currentColor"/>
  </svg>
);

export const Close24 = (p: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
  </svg>
);

export const ViewAll24 = (p: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path d="M3 12.9999H5V10.9999H3V12.9999ZM3 16.9999H5V14.9999H3V16.9999ZM3 8.99988H5V6.99988H3V8.99988ZM7 12.9999H21V10.9999H7V12.9999ZM7 16.9999H21V14.9999H7V16.9999ZM7 6.99988V8.99988H21V6.99988H7Z" fill="currentColor"/>
  </svg>
);

export const ShoppingBag24 = (p: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path d="M20 8L21 22H3L4 8H20ZM12 2C14.755 2 17 4.245 17 7H15C15 5.345 13.655 4 12 4C10.345 4 9 5.345 9 7H7C7 4.245 9.245 2 12 2Z" fill="currentColor"/>
  </svg>
);

export const FlowArrow = (p: IconProps) => (
  <svg width="46" height="14.7279" viewBox="0 0 46 14.7279" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path d="M45.7071 8.07107C46.0976 7.68054 46.0976 7.04738 45.7071 6.65685L39.3431 0.292893C38.9526 -0.097631 38.3195 -0.097631 37.9289 0.292893C37.5384 0.683418 37.5384 1.31658 37.9289 1.70711L43.5858 7.36396L37.9289 13.0208C37.5384 13.4113 37.5384 14.0445 37.9289 14.435C38.3195 14.8256 38.9526 14.8256 39.3431 14.435L45.7071 8.07107ZM0 7.36396V8.36396H45V7.36396V6.36396H0V7.36396Z" fill="currentColor"/>
  </svg>
);

export const FlowArrowShort = (p: IconProps) => (
  <svg width="16" height="14.7279" viewBox="0 0 16 14.7279" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path d="M15.7071 8.07107C16.0976 7.68054 16.0976 7.04738 15.7071 6.65685L9.34315 0.292893C8.95262 -0.097631 8.31946 -0.097631 7.92893 0.292893C7.53841 0.683418 7.53841 1.31658 7.92893 1.70711L13.5858 7.36396L7.92893 13.0208C7.53841 13.4113 7.53841 14.0445 7.92893 14.435C8.31946 14.8256 8.95262 14.8256 9.34315 14.435L15.7071 8.07107ZM0 7.36396V8.36396H15V7.36396V6.36396H0V7.36396Z" fill="currentColor"/>
  </svg>
);

export const ChevronUp24 = (p: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false" {...p}>
    <path fillRule="evenodd" clipRule="evenodd" d="M5 15.4937L12.4937 8L19.9874 15.4937L18.7033 16.7778L12.4937 10.5682L6.28409 16.7778L5 15.4937Z" fill="currentColor"/>
  </svg>
);